function n(n,r){if(null==n)return{};var e={};for(var f in n)if({}.hasOwnProperty.call(n,f)){if(-1!==r.indexOf(f))continue;e[f]=n[f]}return e}export{n as default};
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
